import { useTheme } from 'react-native-paper';

export type BannerType = 'success' | 'error' | 'warning' | 'info';

interface ColorType {
  background: string;
  border: string;
  text: string;
}

export function useBannerColor(type: BannerType) {
  const { colors } = useTheme();

  const colorTypes: Record<BannerType, ColorType> = {
    success: {
      background: colors.toastSuccessBackground,
      border: colors.toastSuccessBorder,
      text: colors.toastSuccessText,
    },
    error: {
      background: colors.toastErrorBackground,
      border: colors.toastErrorBorder,
      text: colors.toastErrorText,
    },
    info: {
      background: colors.toastInfoBackground,
      border: colors.toastInfoBorder,
      text: colors.toastInfoText,
    },
    warning: {
      background: colors.toastWarningBackground,
      border: colors.toastWarningBorder,
      text: colors.toastWarningText,
    },
  };

  return {
    colorType: colorTypes[type],
  };
}
